import { z } from 'zod';
import { createResponseSchema } from '../../../schemas/repository.schemas';
import { tableDiffSchema } from '../../../schemas/schemaDiff.schemas';

export const tableDiffResponseSchema = createResponseSchema(tableDiffSchema);
export type TableDiffResponseType = z.infer<typeof tableDiffResponseSchema>;
